"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SyncController", {
    enumerable: true,
    get: function() {
        return SyncController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _syncservice = require("~/services/sync.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let SyncController = class SyncController {
    async syncSourceList(context, baseId, sourceId) {
        return await this.syncService.syncSourceList(context, {
            baseId,
            sourceId
        });
    }
    async syncCreate(context, baseId, body, req, sourceId) {
        return await this.syncService.syncCreate(context, {
            baseId: baseId,
            sourceId: sourceId,
            userId: req.user.id,
            syncPayload: body,
            req
        });
    }
    async syncDelete(context, syncId, req) {
        return await this.syncService.syncDelete(context, {
            syncId: syncId,
            req
        });
    }
    async syncUpdate(context, syncId, body, req) {
        return await this.syncService.syncUpdate(context, {
            syncId: syncId,
            syncPayload: body,
            req
        });
    }
    constructor(syncService){
        this.syncService = syncService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/syncs',
        '/api/v1/db/meta/projects/:baseId/syncs/:sourceId',
        '/api/v2/meta/bases/:baseId/syncs',
        '/api/v2/meta/bases/:baseId/syncs/:sourceId'
    ]),
    (0, _extractidsmiddleware.Acl)('syncSourceList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SyncController.prototype, "syncSourceList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/syncs',
        '/api/v1/db/meta/projects/:baseId/syncs/:sourceId',
        '/api/v2/meta/bases/:baseId/syncs',
        '/api/v2/meta/bases/:baseId/syncs/:sourceId'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('syncSourceCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_param(4, (0, _common.Param)('sourceId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SyncController.prototype, "syncCreate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/syncs/:syncId',
        '/api/v2/meta/syncs/:syncId'
    ]),
    (0, _extractidsmiddleware.Acl)('syncSourceDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('syncId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SyncController.prototype, "syncDelete", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/syncs/:syncId',
        '/api/v2/meta/syncs/:syncId'
    ]),
    (0, _extractidsmiddleware.Acl)('syncSourceUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('syncId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SyncController.prototype, "syncUpdate", null);
SyncController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _syncservice.SyncService === "undefined" ? Object : _syncservice.SyncService
    ])
], SyncController);
